import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter as Router,
  useLocation,
} from "react-router-dom";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import withRouter from "../hooks/withRouter";
import AppRoutes from "./routes";
import i18n, { detectRegionFromIP } from "../i18n/config";
import "./App.css";

function _ScrollToTop(props) {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return props.children;
}
const ScrollToTop = withRouter(_ScrollToTop);

export default function App() {
  // Subtle inertia/"weighted" scroll (web + mobile) via Lenis.
  useEffect(() => {
    const prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (prefersReduced) return;

    const lenis = new Lenis({
      lerp: 0.15, // higher = snappier, lower = heavier; 0.15 = light drag
      smoothWheel: true,
      syncTouch: true, // gentle inertia on touch devices too
      syncTouchLerp: 0.08,
      touchInertiaMultiplier: 12,
    });
    window.__lenis = lenis;

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    // 첫 마운트 후 비동기 IP 감지로 언어 설정 (비차단)
    const stored = localStorage.getItem('i18nextLng');
    if (!stored) {
      detectRegionFromIP().then((lng) => {
        const normalized = (lng || 'en').split('-')[0];
        if (normalized !== i18n.language) {
          i18n.changeLanguage(normalized);
        }
        localStorage.setItem('i18nextLng', normalized);
      }).catch(() => {
        // 실패 시 아무 것도 하지 않음 (fallbackLng 동작)
      });
    }
  }, []);

  return (
    <Router basename={process.env.PUBLIC_URL}>
      <ScrollToTop>
        <AppRoutes />
      </ScrollToTop>
    </Router>
  );
}
